module.exports = __webpack_public_path__ + "static/downloads-43e5aca99a541beebfdbe58eab525d85.jpg";